import React from 'react';
import { CanvasServiceBox, Disclaimer, ServicesTitle, extractServiceInfo } from "../Services";
import { ReadLess } from '../../../common/commonUtils';
import Header from '../../navigation/Header';
import Footer from '../../footer/Footer';
import Stack from '@mui/material/Stack';
import "../Services.css"

function Body() {
    const serviceInfo = extractServiceInfo()
    return (
        <div className='mobile-view'>
            <ServicesTitle/>
            <div className='stack-row-container-read-more'>
                <Stack direction='column'>
                    <CanvasServiceBox
                        hideDescriptions={false}
                        desktopView={true}
                        canvasInfo={serviceInfo.canvasInfo}
                    />
                    <Disclaimer
                        bodyText={serviceInfo.disclaimer}
                    />
                </Stack>
            </div>
            <ReadLess
                page="services"
            />
        </div>
    )
}

export default function Canvas() {
    return (
        <div className='services-container'>
        <Header/>
        <Body/>
        <Footer/>
        </div>
    )
}